import * as siteStructureService from '@wix/auto_sdk_viewer_site-structure-service';

export { siteStructureService };
